import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';

import $ from 'jquery';
import mapboxgl from 'mapbox-gl';

import { measurementHasEnded } from './date';

const BBOX_OPTIONS = { padding: 100 };
class IconFactory {
  constructor(irrigation, noIrrigation) {
    this.irrigation = irrigation;
    this.noIrrigation = noIrrigation;
  }
  make(irrigation, color) {
    const target = (irrigation === 'unbewaessert') ? this.noIrrigation : this.irrigation;
    const icon = target.cloneNode(true);
    icon.setAttribute('class', 'mapIcon');
    icon.getElementsByTagName('circle')[0].style.fill = color;
    return icon;
  }
}

const loadSvgs = function() {
  // get image promises
  const noIrrigation = getSvg('no_irrigation');
  const irrigation = getSvg('irrigation');
  // await simulation (await isn't IE compatible)
  return new Promise(function(resolve) {
    noIrrigation.then((noIrrigation) => {
      irrigation.then((irrigation) => {
        resolve(new IconFactory(irrigation, noIrrigation));
      });
    });
  });
};
const getSvg  = function(img) {
  return fetch(`/theme/img/map-${img}.svg`, {})
    .then(response => response.text())
    .then((data) => {
      const xmlParser = new DOMParser();
      const svg = xmlParser.parseFromString(data, 'text/xml');
      return svg.documentElement;
    });
};

/** A station shows itself both in a list and on a map.
 *
 * You can tell it to show() and hide(). You can also ask
 * whether it matches() a keyword, which can be a name or a
 * serial-number.
 *
 * @param item     jquery set with list entry item
 * @param station  dictionary with station fields title, sn, lng, lat
 * @param map_data dictionary with popup requisites such as api (an URL), lang, and key
 * @param icons IconFactory with make function.
 */
const station = function(item, station, mapData, icons) {
  const COLOR_DEFAULT = '#fff';
  const COLOR_MAINTENANCE = '#808080';

  const STATION_IMAGES = {
    flag_ended: 'stations-flag-end-of-measurements.svg',
    flag_maintenance: 'stations-flag-maintenance.svg',
    flag_no_data: 'stations-flag-no-data.svg',
    maintenance: 'stations-maintenance.svg',
  };

  const coords = [parseFloat(station.lng), parseFloat(station.lat)];
  const ended = measurementHasEnded(station.measurementEnd);

  let marker = false;

  const { api, lang, key } = mapData;

  let { color } = station;
  let popupContent = `<iframe src="${api}${station.id}?${$.param({ lang, key })}"></iframe>`;
  const imgPopup = function(img, alt) {
    return `<img src="/theme/img/${img}" alt="${alt}" class="flagIcon"/>`;
  };

  // Priorities: 1. Ended?; 2. Maintenance?; 3. No Data?
  if (ended) {
    color = COLOR_DEFAULT;
    popupContent = imgPopup(STATION_IMAGES.flag_ended, 'Measurement ended');
  } else if (station.maintenance === 1) {
    color = COLOR_MAINTENANCE;
    popupContent = imgPopup(STATION_IMAGES.flag_maintenance, 'Under maintenance');
  } else if (station.color === 'no-data') {
    color = COLOR_MAINTENANCE;
    popupContent = imgPopup(STATION_IMAGES.flag_no_data, 'Not sending data');
  }

  const makePopup = function() {
    const content = `
      <strong>${station.title}</strong>
      ${popupContent}
      <a href="${station.url}">Details</a>
    `;
    return new mapboxgl.Popup().setHTML(content);
  };

  return {
    coords,

    matches(keyword) {
      const keywordLc = keyword.toLowerCase();
      if (station.title.toLowerCase().indexOf(keywordLc) >= 0) {
        return true;
      }
      if ((`${station.sn}`).toLowerCase().indexOf(keywordLc) === 0) {
        return true;
      }
      return false;
    },

    show(map) {
      item.show();
      if (marker) return;

      // How to add a marker to a MapBox GL JS map?
      // https://stackoverflow.com/a/44318968
      const el = document.createElement('div');
      el.className = 'station';
      el.style.cursor = 'pointer';

      const icon = icons.make(station.irrigation, color);

      el.appendChild(icon);

      el.addEventListener('click', function(event) {
        event.preventDefault();

        const popup = makePopup().setLngLat(coords);

        // Adding the popup to the map straight away doesn't show it.
        // HACK I have no Idea why defering here helps showing
        // the popup. Seems like MapboxGL is broken.
        window.setTimeout(() => popup.addTo(map), 0);
      });

      marker = new mapboxgl.Marker(el).setLngLat(coords)
        .addTo(map);
    },

    hide() {
      item.hide();
      if (marker !== false) {
        marker.remove();
        marker = false;
      }
    },
  };
};

const stationSet = function(map, stations) {
  let filter = false;

  const update = function() {
    const bounds = new mapboxgl.LngLatBounds();
    stations.forEach((station) => {
      if (filter === false || station.matches(filter)) {
        station.show(map);
        bounds.extend(station.coords);
      } else {
        station.hide();
      }
    });
    map.fitBounds(bounds, BBOX_OPTIONS);
  };

  map.on('load', update);

  return {
    filter(keyword) {
      filter = keyword;
      update();
    },
  };
};

export const initializeMap = function() {
  loadSvgs().then((icons) => {
    const $MAP = $('.map');
    const $SEARCH = $('.searchField');

    if ($MAP.length === 0 || $SEARCH.length === 0) {
      return;
    }

    const mapData = $MAP.data();


    // Map
    mapboxgl.accessToken = 'pk.eyJ1IjoibWV0ZW90ZXN0IiwiYSI6Ik04ZXJpZm8ifQ.7bC_VfpMUnbPlbn1F22ijA';

    const map = new mapboxgl.Map({
      container: $MAP.get(0),
      style: 'mapbox://styles/meteotest/cjdizq3fb1ep12rsu829pf20c',
      center: [7.466965, 46.990885],
      zoom: 10,
      maxZoom: 13,
      minZoom: 6,
    });

    // Search & Markers
    const $INPUT = $SEARCH.find('#search-input');
    const $BUTTON = $SEARCH.find('button[name="button"]');
    const $STATIONS = $SEARCH.find('#search-results > *');

    const stations = $STATIONS.map((_, el) => {
      const item = $(el);
      return station(item, item.data(), mapData, icons);
    })
      .get();

    const stationset = stationSet(map, stations);

    const submitForm = function() {
      stationset.filter($INPUT.val());
    };

    $BUTTON.on('click', submitForm);

    $INPUT.on('keyup', (event) => {
      if (event.which === 13 /* ENTER */) {
        submitForm();
      }
    });
  });
};



// WEBPACK FOOTER //
// ./theme_src/js/map.js